import { IS_TEST_MODE } from 'constants/global';

const isEnv = (env: string) => window.location.origin.includes(env);

export enum EnvName {
	PRODUCTION = 'production',
	SANDBOX = 'sandbox',
	DEV = 'dev',
	LOCAL = 'local',
	TEST = 'test',
	NONE = 'none'
}

export const EnvDomain = {
	[EnvName.PRODUCTION]: 'app.descope.com',
	[EnvName.SANDBOX]: 'app.descope.org',
	[EnvName.DEV]: 'preview.descope.org',
	[EnvName.LOCAL]: 'localhost',
	[EnvName.TEST]: 'localhost'
};

export const downloadAsFile = (
	data: Blob | Record<string, any>,
	fileName?: string
) => {
	let blob: Blob;
	if (data instanceof Blob) {
		blob = data;
	} else {
		const json = JSON.stringify(data);
		blob = new Blob([json]);
	}
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', fileName || '');
	document.body.appendChild(link);
	link.click();
};

export const sleep = async (ms: number) =>
	// eslint-disable-next-line no-promise-executor-return
	new Promise((resolve) => setTimeout(resolve, IS_TEST_MODE ? 0 : ms));

export const isProd = () => isEnv(EnvDomain.production);
export const isSandbox = () => isEnv(EnvDomain.sandbox);
export const isDev = () => isEnv(EnvDomain.dev);
export const isLocal = () => isEnv(EnvDomain.local);
